import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Institution } from './Institution';

export interface FeedbackFormRow {
  id: number;
  title: string;
  institution_id: number;
  internal_external_mode: string;
  external_form_url: string;
}

export const FeedbackForm: Entity<FeedbackFormRow> = {
  id: 'FeedbackForm',
  title: 'Feedback Form',
  service: 'main',
  rowLabel: (row: FeedbackFormRow) => row.title,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.feedback_form',
  },
  security: [
    { role: 'user', action: 'read', access: 'all' },
    { role: 'admin', action: 'read', access: 'all' },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: 'institution_id = {adminInstitutionId}',
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['title', 'ASC']],
  defaultFilters: [{ fieldId: 'title', operator: 'ct', value: '' }],
  listRowLink: '/admin/feedback-form/display/{key}',
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    title: {
      seq: 10,
      label: 'Title',
      type: FieldType.Text,
      mandatory: true,
      listColumn: true,
      maxLength: 255,
    },
    institution_id: {
      seq: 15,
      type: FieldType.Reference,
      label: 'Institution',
      persistence: PersistenceType.SetOnCreateOnly,
      refEntity: Institution,
    },
    internal_external_mode: {
      seq: 20,
      type: FieldType.Options,
      label: `Use our form or an external one or both`,
      mandatory: true,
      options: [
        { id: 'internal', label: 'Careerbook form only' },
        { id: 'external', label: 'External form only' },
        // not used for now - probably confusing and unnecessary
        { id: 'both', label: 'both Careerbook and External forms', active: false },
      ],
    },
    external_form_url: {
      seq: 25,
      type: FieldType.Text,
      label: `External Form URL`,
      maxLength: 1000,
    },
  },
};
